import React from 'react';
import InfoTooltip from 'containers/Tooltips/InfoTooltip/InfoTooltip';
import BaseTile from '../BaseTile/BaseTile';
import Button from 'commonComponents/Button/Button';
import styles from './CurrentOpportunityTile.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const CurrentOpportunityTile = ({ photo, title, subtitle, rows, button, opportunity }) => {

  const content = (
    <div className={ styles.CurrentOpportunityTile }>
      <h5 className={ styles.title }>{ title }</h5>
      <p className={ styles.subtitle }>{ subtitle }</p>
      <div className={ styles.text }>
        {
          rows.map((item, i) =>
            <div className={ styles.row } key={ i } >
              <div className={ styles.keys } >
                { item.key }
                { item.tip &&
                <InfoTooltip place="start">
                  { item.tip }
                </InfoTooltip>
                }
              </div>
              <div className={ styles.values } >
                { item.value }
              </div>
            </div>
          )
        }
      </div>
      <Button
        label={ button.label }
        link={ `${button.link}?${opportunity}=true` }
        type="fullWidth"
      />
    </div>
  );

  const tileProps = { photo, content };

  return <BaseTile { ...tileProps } />;
};

export default CurrentOpportunityTile;
